"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _getGuid = _interopRequireDefault(require("../../utils/guid/getGuid"));

var AudioController = /*#__PURE__*/function () {
  /**
   * Buffer ID
   */

  /**
   * Audio's play state
   */

  /**
   * Audio's reference ID
   */

  /**
   * Play speed
   */

  /**
   * Play volume
   */
  function AudioController() {
    (0, _classCallCheck2["default"])(this, AudioController);
    (0, _defineProperty2["default"])(this, "_bufferId", void 0);
    (0, _defineProperty2["default"])(this, "_playing", void 0);
    (0, _defineProperty2["default"])(this, "_referenceId", void 0);
    (0, _defineProperty2["default"])(this, "_speed", void 0);
    (0, _defineProperty2["default"])(this, "_volume", void 0);
    this._bufferId = (0, _getGuid["default"])();
    this._playing = false;
    this._referenceId = (0, _getGuid["default"])();
    this._speed = 1;
    this._volume = 0;
  }

  (0, _createClass2["default"])(AudioController, [{
    key: "clear",
    value: function clear() {
      throw new Error('clear must be implemented by subclass of AudioController');
    }
  }, {
    key: "play",
    value: function play() {
      throw new Error('play must be implemented by subclass of AudioController');
    }
  }, {
    key: "stop",
    value: function stop() {
      throw new Error('stop must be implemented by subclass of AudioController');
    }
  }, {
    key: "load",
    value: function load() {
      throw new Error('load must be implemented by subclass of AudioController');
    }
    /**
     * Checks if object is an instance of AudioController
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "bufferId",
    get: function get() {
      return this._bufferId;
    }
  }, {
    key: "playing",
    get: function get() {
      return this._playing;
    },
    set: function set(value) {
      this._playing = value;
    }
  }, {
    key: "referenceId",
    get: function get() {
      return this._referenceId;
    }
  }, {
    key: "speed",
    get: function get() {
      return this._speed;
    },
    set: function set(value) {
      this._value = value;
    }
  }, {
    key: "volume",
    get: function get() {
      return this._volume;
    },
    set: function set(value) {
      this._value = value;
    }
  }], [{
    key: "isAudioController",
    value: function isAudioController(inputObject) {
      return inputObject instanceof AudioController;
    }
  }]);
  return AudioController;
}();

var _default = AudioController;
exports["default"] = _default;